<template lang="pug">
  el-form(label-position='top' ref='form' :model='changePassword' :rules='rules')
    el-form-item(v-if='requireOldPassword' label="Old password" prop="oldPassword")
      el-input(v-model="changePassword.oldPassword" type='password')

    el-form-item(label="New password" prop="newPassword")
      el-input(v-model="changePassword.newPassword" type='password')

    el-form-item(label="Confirm password" prop="confirmPassword")
      el-input(v-model="changePassword.confirmPassword" type='password')

    el-checkbox(v-if='showNotify' v-model="changePassword.notify") Send new password by email

</template>

<script>
export default {
  model: {
    prop: "changePassword",
    event: "change"
  },
  props: {
    changePassword: {
      type: Object,
      default: () => ({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        notify: false
      })
    },
    showNotify: {
      type: Boolean,
      default: true
    },
    requireOldPassword: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: {
        oldPassword: [
          { validator: this.validateOldPassword, trigger: "change" }
        ],
        newPassword: [{ validator: this.validatePassword, trigger: "change" }],
        confirmPassword: [
          { validator: this.validateConfirmPassword, trigger: "change" }
        ]
      }
    };
  },
  methods: {
    validateOldPassword(rule, value, callback) {
      if (this.requireOldPassword && !value) {
        return callback(new Error("This field is required"));
      }
      return callback();
    },
    validatePassword(rule, value, callback) {
      if (this.changePassword.generatePassword) {
        return callback();
      }

      if (!value) {
        return callback(new Error("This field is required"));
      }

      const regex = /^(?=.*\d)(?=.*[a-z])[0-9a-zA-Z]{8,}$/;

      if (!regex.test(value)) {
        return callback(
          new Error(
            "Password must be at least 8 characters, at least 1 number and at least 1 lowercase letter."
          )
        );
      }

      return callback();
    },
    validateConfirmPassword(rule, _value, callback) {
      if (
        !this.changePassword.confirmPassword ||
        this.changePassword.confirmPassword !== this.changePassword.newPassword
      ) {
        return callback(new Error("Passwords don't match"));
      }
      return callback();
    },
    validate(...args) {
      return this.$refs.form.validate(...args);
    },
    resetFields(...args) {
      return this.$refs.form.resetFields(...args);
    }
  }
};
</script>

<style scoped lang="scss"></style>
